module.exports = __webpack_public_path__ + "static/img/newThree.027bec8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newThree.png
// module id = Nfuc
// module chunks = 1